/**
 * German profanity data
 * Auto-generated from JSON files - DO NOT EDIT MANUALLY
 *
 * Language: German
 * Version: 1.0.0
 * Last Updated: 2025-09-30
 * Total Entries: 226
 */

export const DE = {
  "metadata": {
    "name": "German",
    "code": "de",
    "version": "1.0.0",
    "lastUpdated": "2025-09-30",
    "wordCount": 226
  },
  "words": [
    {
      "word": "@rschloch",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "@rschl0ch",
        "@*schloch"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Low - already compound"
    },
    {
      "word": "**allowlisting**: permit legitimate uses of ambiguous words in appropriate contexts",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "**@ll0wl1st1ng**: p3rm1t l3g1t1m@t3 us3s 0f @mb1gu0us w0rds 1n @ppr0pr1@t3 c0nt3xts",
        "**allowlisting**: permit legitimate uses of ambiguous words in appropriate contexts"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "**compound detection**: implement prefix/suffix pattern matching for german compounds",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "**c0mp0und d3t3ct10n**: 1mpl3m3nt pr3f1x/suff1x p@tt3rn m@tch1ng f0r g3rm@n c0mp0unds",
        "**compound detection**: implement prefix/suffix pattern matching for german compounds"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "**context awareness**: consider implementing context analysis for ambiguous terms",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "**context awareneß**: consider implementing context analysis for ambiguous terms",
        "**c0nt3xt @w@r3n3ss**: c0ns1d3r 1mpl3m3nt1ng c0nt3xt @n@lys1s f0r @mb1gu0us t3rms",
        "**context awareness**: consider implementing context analysis for ambiguous terms"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "**leet speak**: include character substitution detection",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "**l33t sp3@k**: 1nclud3 ch@r@ct3r subst1tut10n d3t3ct10n",
        "**leet speak**: include character substitution detection"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "**regional settings**: allow users to specify german variant (de, at, ch) for relevant filtering",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "**r3g10n@l s3tt1ngs**: @ll0w us3rs t0 sp3c1fy g3rm@n v@r1@nt (d3, @t, ch) f0r r3l3v@nt f1lt3r1ng",
        "**regional settings**: allow users to specify german variant (de, at, ch) for relevant filtering"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "**severity filtering**: support configurable severity thresholds",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "**s3v3r1ty f1lt3r1ng**: supp0rt c0nf1gur@bl3 s3v3r1ty thr3sh0lds",
        "**severity filtering**: support configurable severity thresholds"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "aalficker",
      "severity": 1,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "@@lf1ck3r",
        "a*lficker"
      ],
      "case_sensitive": false,
      "context_notes": "Sexual/vulgar term",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "affe",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "@ff3",
        "a*fe"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "affenarsch",
      "severity": 1,
      "categories": [
        "body_parts",
        "general"
      ],
      "variations": [
        "@ff3n@rsch",
        "a*fenarsch"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "analritter",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "@n@lr1tt3r",
        "a*alritter"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "armleuchter",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "@rml3ucht3r",
        "a*mleuchter"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "arsch",
      "severity": 1,
      "categories": [
        "body_parts",
        "general"
      ],
      "variations": [
        "@rsch",
        "a*sch"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Very high"
    },
    {
      "word": "arschficker",
      "severity": 1,
      "categories": [
        "sexual",
        "body_parts",
        "general"
      ],
      "variations": [
        "@rschf1ck3r",
        "a*schficker"
      ],
      "case_sensitive": false,
      "context_notes": "Sexual/vulgar term",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Very high"
    },
    {
      "word": "arschgeige",
      "severity": 1,
      "categories": [
        "body_parts",
        "general"
      ],
      "variations": [
        "@rschg31g3",
        "a*schgeige"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Very high"
    },
    {
      "word": "arschgesicht",
      "severity": 1,
      "categories": [
        "body_parts",
        "general"
      ],
      "variations": [
        "@rschg3s1cht",
        "a*schgesicht"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Very high"
    },
    {
      "word": "arschkopf",
      "severity": 1,
      "categories": [
        "body_parts",
        "general"
      ],
      "variations": [
        "@rschk0pf",
        "a*schkopf"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Very high"
    },
    {
      "word": "arschkrampe",
      "severity": 1,
      "categories": [
        "body_parts",
        "general"
      ],
      "variations": [
        "@rschkr@mp3",
        "a*schkrampe"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Very high"
    },
    {
      "word": "arschkriecher",
      "severity": 1,
      "categories": [
        "body_parts",
        "general"
      ],
      "variations": [
        "@rschkr13ch3r",
        "a*schkriecher"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Very high"
    },
    {
      "word": "arschlecker",
      "severity": 1,
      "categories": [
        "body_parts",
        "general"
      ],
      "variations": [
        "@rschl3ck3r",
        "a*schlecker"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Very high"
    },
    {
      "word": "arschloch",
      "severity": 2,
      "categories": [
        "general",
        "slurs",
        "body_parts"
      ],
      "variations": [
        "arschl0ch",
        "@rschloch",
        "arsch"
      ],
      "case_sensitive": false,
      "context_notes": "Common insult meaning 'asshole', moderately offensive",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium - compound with other terms"
    },
    {
      "word": "bastard",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "b@st@rd",
        "b*stard"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "bimbo",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "b1mb0",
        "b*mbo"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "blödian",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "blöd1@n",
        "b*ödian"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "blödmann",
      "severity": 1,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "bl*dmann",
        "bldmn"
      ],
      "case_sensitive": false,
      "context_notes": "Stupid person, mild insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "bratze",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "br@tz3",
        "b*atze"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "brunzkachel",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "brunzk@ch3l",
        "b*unzkachel"
      ],
      "case_sensitive": false,
      "context_notes": "Austrian German specific term",
      "target_type": "individual",
      "regions": [
        "austria"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "bums",
      "severity": 1,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "b*ms"
      ],
      "case_sensitive": false,
      "context_notes": "Sexual/vulgar term",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "bumsen",
      "severity": 1,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "bums3n",
        "b*msen"
      ],
      "case_sensitive": false,
      "context_notes": "Sexual/vulgar term",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "check for false friend conflicts",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "ch3ck f0r f@ls3 fr13nd c0nfl1cts",
        "c*eck for false friend conflicts"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "clown",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "cl0wn",
        "c*own"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "depp",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "d3pp",
        "d*pp"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "dick",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "d1ck",
        "d*ck"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "document cultural context",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "d0cum3nt cultur@l c0nt3xt",
        "d*cument cultural context"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "dödel",
      "severity": 1,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "död3l",
        "d*del"
      ],
      "case_sensitive": false,
      "context_notes": "Sexual/vulgar term",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "dorfdepp",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "d0rfd3pp",
        "d*rfdepp"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "drecksack",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "dr3cksack",
        "drcksk"
      ],
      "case_sensitive": false,
      "context_notes": "Dirt bag, moderate insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Low - already compound"
    },
    {
      "word": "drecksau",
      "severity": 2,
      "categories": [
        "scatological",
        "slurs",
        "general"
      ],
      "variations": [
        "dr3cks@u",
        "d*ecksau"
      ],
      "case_sensitive": false,
      "context_notes": "Scatological term",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Very high"
    },
    {
      "word": "drecksfotze",
      "severity": 1,
      "categories": [
        "sexual",
        "scatological",
        "body_parts",
        "general"
      ],
      "variations": [
        "dr3cksf0tz3",
        "d*ecksfotze"
      ],
      "case_sensitive": false,
      "context_notes": "Sexual/vulgar term",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Very high"
    },
    {
      "word": "drecksschwein",
      "severity": 1,
      "categories": [
        "scatological",
        "slurs",
        "general"
      ],
      "variations": [
        "dreckßchwein",
        "dr3cksschw31n",
        "d*ecksschwein"
      ],
      "case_sensitive": false,
      "context_notes": "Scatological term",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Very high"
    },
    {
      "word": "dummkopf",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "dummk0pf",
        "d*mmkopf"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Low - already compound"
    },
    {
      "word": "dummrian",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "dummr1@n",
        "d*mmrian"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "dumpfbacke",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "dumpfb@ck3",
        "d*mpfbacke"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "dussel",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "dußel",
        "duss3l",
        "d*ssel"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "eierkopf",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "313rk0pf",
        "e*erkopf"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Low - already compound"
    },
    {
      "word": "einfaltspinsel",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "31nf@ltsp1ns3l",
        "e*nfaltspinsel"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "esel",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "3s3l",
        "e*el"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "f*cken",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "f*ck3n",
        "f*cken"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "f1cken",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "f1ck3n",
        "f*cken"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "faulpelz",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "f@ulp3lz",
        "f*ulpelz"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "fettsack",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "f3tts@ck",
        "f*ttsack"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Low - already compound"
    },
    {
      "word": "fetzenschädel",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "f3tz3nschäd3l",
        "f*tzenschädel"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "fick",
      "severity": 1,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "f1ck",
        "f*ck"
      ],
      "case_sensitive": false,
      "context_notes": "Sexual/vulgar term",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "compound_potential": "Very high"
    },
    {
      "word": "ficken",
      "severity": 3,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "f1cken",
        "f*cken",
        "gevögelt"
      ],
      "case_sensitive": false,
      "context_notes": "Sexual verb meaning 'to fuck', highly versatile",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "compound_potential": "Very high - Fickfehler, etc."
    },
    {
      "word": "fickfehler",
      "severity": 1,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "f1ckf3hl3r",
        "f*ckfehler"
      ],
      "case_sensitive": false,
      "context_notes": "Sexual/vulgar term",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Very high"
    },
    {
      "word": "fickfresse",
      "severity": 1,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "fickfreße",
        "f1ckfr3ss3",
        "f*ckfresse"
      ],
      "case_sensitive": false,
      "context_notes": "Sexual/vulgar term",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Very high"
    },
    {
      "word": "fischkopp",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "f1schk0pp",
        "f*schkopp"
      ],
      "case_sensitive": false,
      "context_notes": "Northern German specific term",
      "target_type": "individual",
      "regions": [
        "northern_germany"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "flasche",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "fl@sch3",
        "f*asche"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "flittchen",
      "severity": 1,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "fl1ttch3n",
        "f*ittchen"
      ],
      "case_sensitive": false,
      "context_notes": "Sexual/vulgar term",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "fotze",
      "severity": 3,
      "categories": [
        "sexual",
        "body_parts",
        "slurs"
      ],
      "variations": [
        "f0tze",
        "f*tze"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely vulgar term for vagina, very offensive to women",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "fratze",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "fr@tz3",
        "f*atze"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "gfrast",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "gfr@st",
        "g*rast"
      ],
      "case_sensitive": false,
      "context_notes": "Austrian German specific term",
      "target_type": "individual",
      "regions": [
        "austria"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "gopfertami",
      "severity": 1,
      "categories": [
        "religious",
        "general"
      ],
      "variations": [
        "g0pf3rt@m1",
        "g*pfertami"
      ],
      "case_sensitive": false,
      "context_notes": "Swiss German specific term",
      "target_type": "individual",
      "regions": [
        "switzerland"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "grantler",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "gr@ntl3r",
        "g*antler"
      ],
      "case_sensitive": false,
      "context_notes": "Bavarian/Southern German specific term",
      "target_type": "individual",
      "regions": [
        "bavaria"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "griasbirn",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "gr1@sb1rn",
        "g*iasbirn"
      ],
      "case_sensitive": false,
      "context_notes": "Bavarian/Southern German specific term",
      "target_type": "individual",
      "regions": [
        "bavaria"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "h*re",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "h*r3",
        "h*re"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "hackfleisch",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "h@ckfl31sch",
        "h*ckfleisch"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "hackfresse",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "hackfreße",
        "h@ckfr3ss3",
        "h*ckfresse"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "hammel",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "h@mm3l",
        "h*mmel"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "hanswurst",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "h@nswurst",
        "h*nswurst"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "heisl",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "h31sl",
        "h*isl"
      ],
      "case_sensitive": false,
      "context_notes": "Austrian German specific term",
      "target_type": "individual",
      "regions": [
        "austria"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "himmiherrgott",
      "severity": 1,
      "categories": [
        "religious",
        "general"
      ],
      "variations": [
        "h1mm1h3rrg0tt",
        "h*mmiherrgott"
      ],
      "case_sensitive": false,
      "context_notes": "Bavarian/Southern German specific term",
      "target_type": "individual",
      "regions": [
        "bavaria"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "hirni",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "h1rn1",
        "h*rni"
      ],
      "case_sensitive": false,
      "context_notes": "Bavarian/Southern German specific term",
      "target_type": "individual",
      "regions": [
        "bavaria"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "hitler",
      "severity": 3,
      "categories": [
        "hate_speech",
        "violence"
      ],
      "variations": [
        "h1tler",
        "htl"
      ],
      "case_sensitive": false,
      "context_notes": "Historical dictator, offensive when used for comparison",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "hohlbirne",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "h0hlb1rn3",
        "h*hlbirne"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "holzkopf",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "h0lzk0pf",
        "h*lzkopf"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Low - already compound"
    },
    {
      "word": "hornochse",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "h0rn0chs3",
        "h*rnochse"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "hosenscheisser",
      "severity": 2,
      "categories": [
        "scatological",
        "general"
      ],
      "variations": [
        "hosenscheißer",
        "h0s3nsch31ss3r",
        "h*senscheisser"
      ],
      "case_sensitive": false,
      "context_notes": "Bavarian/Southern German specific term",
      "target_type": "individual",
      "regions": [
        "bavaria"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "huere",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "hu3r3",
        "h*ere"
      ],
      "case_sensitive": false,
      "context_notes": "Swiss German specific term",
      "target_type": "individual",
      "regions": [
        "switzerland"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "hur3",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "h*r3"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "hure",
      "severity": 3,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "hur3",
        "h*re",
        "nutte"
      ],
      "case_sensitive": false,
      "context_notes": "Highly offensive term for prostitute, very degrading to women",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "High - Hurensohn, etc."
    },
    {
      "word": "hurenkind",
      "severity": 2,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "hur3nk1nd",
        "h*renkind"
      ],
      "case_sensitive": false,
      "context_notes": "Sexual/vulgar term",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Very high"
    },
    {
      "word": "hurensohn",
      "severity": 3,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "hurs0n",
        "hu5n",
        "hurns"
      ],
      "case_sensitive": false,
      "context_notes": "Son of a whore, very offensive compound insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium - already a compound"
    },
    {
      "word": "idiot",
      "severity": 1,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "1diot",
        "id10t"
      ],
      "case_sensitive": false,
      "context_notes": "Universal mild insult meaning idiot",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium - Vollidioit, etc."
    },
    {
      "word": "indicate severity level",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "1nd1c@t3 s3v3r1ty l3v3l",
        "i*dicate severity level"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "ische",
      "severity": 1,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "1sch3",
        "i*che"
      ],
      "case_sensitive": false,
      "context_notes": "Sexual/vulgar term",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "judensau",
      "severity": 4,
      "categories": [
        "hate_speech",
        "slurs",
        "religious"
      ],
      "variations": [
        "jud3nsau",
        "j*densau"
      ],
      "case_sensitive": false,
      "context_notes": "Antisemitic slur, historically and contemporarily extremely offensive",
      "target_type": "group",
      "regions": [
        "all"
      ],
      "compound_potential": "Low - already compound"
    },
    {
      "word": "kackbratze",
      "severity": 1,
      "categories": [
        "scatological",
        "general"
      ],
      "variations": [
        "k@ckbr@tz3",
        "k*ckbratze"
      ],
      "case_sensitive": false,
      "context_notes": "Scatological term",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Very high"
    },
    {
      "word": "kacke",
      "severity": 1,
      "categories": [
        "general",
        "scatological"
      ],
      "variations": [
        "k@cke",
        "kck"
      ],
      "case_sensitive": false,
      "context_notes": "Shit, mild profanity, childish equivalent of Scheisse",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "compound_potential": "High"
    },
    {
      "word": "kacken",
      "severity": 1,
      "categories": [
        "scatological",
        "general"
      ],
      "variations": [
        "k@ck3n",
        "k*cken"
      ],
      "case_sensitive": false,
      "context_notes": "Scatological term",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Very high"
    },
    {
      "word": "kackwurst",
      "severity": 1,
      "categories": [
        "scatological",
        "general"
      ],
      "variations": [
        "k@ckwurst",
        "k*ckwurst"
      ],
      "case_sensitive": false,
      "context_notes": "Scatological term",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Very high"
    },
    {
      "word": "kampflesbe",
      "severity": 1,
      "categories": [
        "sexual",
        "hate_speech"
      ],
      "variations": [
        "k@mpfl3sb3",
        "k*mpflesbe"
      ],
      "case_sensitive": false,
      "context_notes": "",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "kanake",
      "severity": 4,
      "categories": [
        "hate_speech",
        "slurs",
        "ethnic"
      ],
      "variations": [
        "kan@ke",
        "knk"
      ],
      "case_sensitive": false,
      "context_notes": "Ethnic slur against people of Turkish/Middle Eastern origin",
      "target_type": "group",
      "regions": [
        "germany",
        "austria"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "kimme",
      "severity": 1,
      "categories": [
        "sexual",
        "body_parts",
        "general"
      ],
      "variations": [
        "k1mm3",
        "k*mme"
      ],
      "case_sensitive": false,
      "context_notes": "Sexual/vulgar term",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "knalltüte",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "kn@lltüt3",
        "k*alltüte"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "kotzbrocken",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "k0tzbr0ck3n",
        "k*tzbrocken"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Very high"
    },
    {
      "word": "kreuzkruzifix",
      "severity": 1,
      "categories": [
        "religious",
        "general"
      ],
      "variations": [
        "kr3uzkruz1f1x",
        "k*euzkruzifix"
      ],
      "case_sensitive": false,
      "context_notes": "Bavarian/Southern German specific term",
      "target_type": "individual",
      "regions": [
        "bavaria"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "krüppel",
      "severity": 4,
      "categories": [
        "hate_speech"
      ],
      "variations": [
        "krüpp3l",
        "k*üppel"
      ],
      "case_sensitive": false,
      "context_notes": "Ableist slur meaning cripple, very offensive",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "kruzifix",
      "severity": 1,
      "categories": [
        "religious",
        "general"
      ],
      "variations": [
        "kruz1f1x",
        "k*uzifix"
      ],
      "case_sensitive": false,
      "context_notes": "Austrian German specific term",
      "target_type": "individual",
      "regions": [
        "austria"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "lackaffe",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "l@ck@ff3",
        "l*ckaffe"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "lahmarsch",
      "severity": 1,
      "categories": [
        "body_parts",
        "general"
      ],
      "variations": [
        "l@hm@rsch",
        "l*hmarsch"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "lappalie",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "l@pp@l13",
        "l*ppalie"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "lauch",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "l@uch",
        "l*uch"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "leck",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "l3ck",
        "l*ck"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "lesbe",
      "severity": 2,
      "categories": [
        "lgbtq",
        "slurs"
      ],
      "variations": [
        "l3sbe",
        "l*sbe"
      ],
      "case_sensitive": false,
      "context_notes": "Can be neutral or mildly offensive depending on context",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Low"
    },
    {
      "word": "lööli",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "lööl1",
        "l*öli"
      ],
      "case_sensitive": false,
      "context_notes": "Swiss German specific term",
      "target_type": "individual",
      "regions": [
        "switzerland"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "luder",
      "severity": 1,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "lud3r",
        "l*der"
      ],
      "case_sensitive": false,
      "context_notes": "Sexual/vulgar term",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "luftpumpe",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "luftpump3",
        "l*ftpumpe"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "lümmel",
      "severity": 1,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "lümm3l",
        "l*mmel"
      ],
      "case_sensitive": false,
      "context_notes": "Sexual/vulgar term",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "lump",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "l*mp"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "macker",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "m@ck3r",
        "m*cker"
      ],
      "case_sensitive": false,
      "context_notes": "Northern German specific term",
      "target_type": "individual",
      "regions": [
        "northern_germany"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "maulheld",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "m@ulh3ld",
        "m*ulheld"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "milf",
      "severity": 1,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "m1lf",
        "m*lf"
      ],
      "case_sensitive": false,
      "context_notes": "Sexual/vulgar term",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "mistkerl",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "m1stk3rl",
        "m*stkerl"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Low - already compound"
    },
    {
      "word": "miststück",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "mistst*ck",
        "mstck"
      ],
      "case_sensitive": false,
      "context_notes": "Piece of shit, general insult with moderate offense",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Low - already compound"
    },
    {
      "word": "mistvieh",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "m1stv13h",
        "m*stvieh"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "mongo",
      "severity": 4,
      "categories": [
        "hate_speech",
        "slurs",
        "disability"
      ],
      "variations": [
        "m0ngo",
        "mng"
      ],
      "case_sensitive": false,
      "context_notes": "Ableist slur from 'mongoloid', extremely offensive",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "möpse",
      "severity": 1,
      "categories": [
        "sexual",
        "body_parts",
        "general"
      ],
      "variations": [
        "möps3",
        "m*pse"
      ],
      "case_sensitive": false,
      "context_notes": "Sexual/vulgar term",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "morgenlatte",
      "severity": 1,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "m0rg3nl@tt3",
        "m*rgenlatte"
      ],
      "case_sensitive": false,
      "context_notes": "Sexual/vulgar term",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "möse",
      "severity": 1,
      "categories": [
        "sexual",
        "body_parts",
        "general"
      ],
      "variations": [
        "mös3",
        "m*se"
      ],
      "case_sensitive": false,
      "context_notes": "Sexual/vulgar term",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "mufti",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "muft1",
        "m*fti"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "muschi",
      "severity": 1,
      "categories": [
        "sexual",
        "body_parts",
        "general"
      ],
      "variations": [
        "musch1",
        "m*schi"
      ],
      "case_sensitive": false,
      "context_notes": "Sexual/vulgar term",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "nackt",
      "severity": 1,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "n@ckt",
        "n*ckt"
      ],
      "case_sensitive": false,
      "context_notes": "Sexual/vulgar term",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "nasenbär",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "n@s3nbär",
        "n*senbär"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "nazi",
      "severity": 4,
      "categories": [
        "hate_speech",
        "violence"
      ],
      "variations": [
        "n@zi",
        "nz"
      ],
      "case_sensitive": false,
      "context_notes": "References fascist ideology, extremely offensive when used as slur",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "High - Nazi-, etc."
    },
    {
      "word": "neger",
      "severity": 4,
      "categories": [
        "hate_speech",
        "slurs",
        "racial"
      ],
      "variations": [
        "n3ger",
        "neg*r"
      ],
      "case_sensitive": false,
      "context_notes": "Racial slur, extremely offensive and inappropriate",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "High - historically used in compounds"
    },
    {
      "word": "nichtsnutz",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "n1chtsnutz",
        "n*chtsnutz"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "nigger",
      "severity": 4,
      "categories": [
        "hate_speech"
      ],
      "variations": [
        "n1gg3r",
        "n*gger"
      ],
      "case_sensitive": false,
      "context_notes": "Racial slur, extremely offensive and illegal in many contexts",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "nippel",
      "severity": 1,
      "categories": [
        "sexual",
        "body_parts",
        "general"
      ],
      "variations": [
        "n1pp3l",
        "n*ppel"
      ],
      "case_sensitive": false,
      "context_notes": "Sexual/vulgar term",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "note any compound potential",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "n0t3 @ny c0mp0und p0t3nt1@l",
        "n*te any compound potential"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "nutte",
      "severity": 1,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "nutt3",
        "n*tte"
      ],
      "case_sensitive": false,
      "context_notes": "Sexual/vulgar term",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "ochse",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "0chs3",
        "o*hse"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "oida",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "01d@",
        "o*da"
      ],
      "case_sensitive": false,
      "context_notes": "Austrian German specific term",
      "target_type": "individual",
      "regions": [
        "austria"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "onanieren",
      "severity": 1,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "0n@n13r3n",
        "o*anieren"
      ],
      "case_sensitive": false,
      "context_notes": "Sexual/vulgar term",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "orgasmus",
      "severity": 1,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "0rg@smus",
        "o*gasmus"
      ],
      "case_sensitive": false,
      "context_notes": "Sexual/vulgar term",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "pansen",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "p@ns3n",
        "p*nsen"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "pappn",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "p@ppn",
        "p*ppn"
      ],
      "case_sensitive": false,
      "context_notes": "Austrian German specific term",
      "target_type": "individual",
      "regions": [
        "austria"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "penis",
      "severity": 1,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "p3n1s",
        "p*nis"
      ],
      "case_sensitive": false,
      "context_notes": "Sexual/vulgar term",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "penner",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "p3nner",
        "pnnr"
      ],
      "case_sensitive": false,
      "context_notes": "Bum/hobo, moderately offensive, classist undertones",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "pimmel",
      "severity": 1,
      "categories": [
        "sexual",
        "body_parts",
        "general"
      ],
      "variations": [
        "p1mm3l",
        "p*mmel"
      ],
      "case_sensitive": false,
      "context_notes": "Sexual/vulgar term",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "pimpern",
      "severity": 1,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "p1mp3rn",
        "p*mpern"
      ],
      "case_sensitive": false,
      "context_notes": "Sexual/vulgar term",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "pinkeln",
      "severity": 1,
      "categories": [
        "scatological",
        "general"
      ],
      "variations": [
        "p1nk3ln",
        "p*nkeln"
      ],
      "case_sensitive": false,
      "context_notes": "Scatological term",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "piss",
      "severity": 1,
      "categories": [
        "general",
        "scatological"
      ],
      "variations": [
        "p1ss",
        "p*ss"
      ],
      "case_sensitive": false,
      "context_notes": "Piss, mild profanity, very common in compounds",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "compound_potential": "Very high - pissed off = pisssauer"
    },
    {
      "word": "pissbude",
      "severity": 1,
      "categories": [
        "scatological",
        "general"
      ],
      "variations": [
        "pißbude",
        "p1ssbud3",
        "p*ssbude"
      ],
      "case_sensitive": false,
      "context_notes": "Scatological term",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Very high"
    },
    {
      "word": "pissen",
      "severity": 1,
      "categories": [
        "scatological",
        "general"
      ],
      "variations": [
        "pißen",
        "p1ss3n",
        "p*ssen"
      ],
      "case_sensitive": false,
      "context_notes": "Scatological term",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Very high"
    },
    {
      "word": "pisser",
      "severity": 1,
      "categories": [
        "scatological",
        "general"
      ],
      "variations": [
        "pißer",
        "p1ss3r",
        "p*sser"
      ],
      "case_sensitive": false,
      "context_notes": "Scatological term",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Very high"
    },
    {
      "word": "pissnelke",
      "severity": 1,
      "categories": [
        "scatological",
        "general"
      ],
      "variations": [
        "pißnelke",
        "p1ssn3lk3",
        "p*ssnelke"
      ],
      "case_sensitive": false,
      "context_notes": "Scatological term",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Very high"
    },
    {
      "word": "pöbel",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "pöb3l",
        "p*bel"
      ],
      "case_sensitive": false,
      "context_notes": "Northern German specific term",
      "target_type": "individual",
      "regions": [
        "northern_germany"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "polacke",
      "severity": 4,
      "categories": [
        "hate_speech",
        "slurs",
        "ethnic"
      ],
      "variations": [
        "pol@cke",
        "plck"
      ],
      "case_sensitive": false,
      "context_notes": "Ethnic slur against Polish people, very offensive",
      "target_type": "group",
      "regions": [
        "germany",
        "austria"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "popel",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "p0p3l",
        "p*pel"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "poppen",
      "severity": 1,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "p0pp3n",
        "p*ppen"
      ],
      "case_sensitive": false,
      "context_notes": "Sexual/vulgar term",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "porno",
      "severity": 1,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "p0rn0",
        "p*rno"
      ],
      "case_sensitive": false,
      "context_notes": "Sexual/vulgar term",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "pullermann",
      "severity": 1,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "pull3rm@nn",
        "p*llermann"
      ],
      "case_sensitive": false,
      "context_notes": "Sexual/vulgar term",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "quatschkopf",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "qu@tschk0pf",
        "q*atschkopf"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Low - already compound"
    },
    {
      "word": "rammeln",
      "severity": 1,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "r@mm3ln",
        "r*mmeln"
      ],
      "case_sensitive": false,
      "context_notes": "Sexual/vulgar term",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "ratte",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "r@tt3",
        "r*tte"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "reudig",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "r3ud1g",
        "r*udig"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "rindvieh",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "r1ndv13h",
        "r*ndvieh"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "rosette",
      "severity": 1,
      "categories": [
        "sexual",
        "body_parts",
        "general"
      ],
      "variations": [
        "r0s3tt3",
        "r*sette"
      ],
      "case_sensitive": false,
      "context_notes": "Sexual/vulgar term",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "rotzlöffel",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "r0tzlöff3l",
        "r*tzlöffel"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "sack",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "s@ck",
        "s*ck"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Low - already compound"
    },
    {
      "word": "sackratte",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "s@ckr@tt3",
        "s*ckratte"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Low - already compound"
    },
    {
      "word": "saftsack",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "s@fts@ck",
        "s*ftsack"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Low - already compound"
    },
    {
      "word": "sau",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "s@u"
      ],
      "case_sensitive": false,
      "context_notes": "Sow/pig, moderate insult, very common in compounds",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Very high - Sauhund, etc."
    },
    {
      "word": "saubär",
      "severity": 2,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "s@ubär",
        "s*ubär"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Very high"
    },
    {
      "word": "saudepp",
      "severity": 2,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "s@ud3pp",
        "s*udepp"
      ],
      "case_sensitive": false,
      "context_notes": "Bavarian/Southern German specific term",
      "target_type": "individual",
      "regions": [
        "bavaria"
      ],
      "compound_potential": "Very high"
    },
    {
      "word": "saukerl",
      "severity": 2,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "s@uk3rl",
        "s*ukerl"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Very high"
    },
    {
      "word": "saupreiß",
      "severity": 2,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "saupreiss",
        "s@upr31ß",
        "s*upreiß"
      ],
      "case_sensitive": false,
      "context_notes": "Bavarian/Southern German specific term",
      "target_type": "individual",
      "regions": [
        "bavaria"
      ],
      "compound_potential": "Very high"
    },
    {
      "word": "sch31sse",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "sch31ße",
        "sch31ss3",
        "s*h31sse"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "sch31ße",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "sch31sse",
        "sch31ß3",
        "s*h31ße"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "schabracke",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "sch@br@ck3",
        "s*habracke"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "scheissdreck",
      "severity": 1,
      "categories": [
        "scatological",
        "general"
      ],
      "variations": [
        "scheißdreck",
        "sch31ssdr3ck",
        "s*heissdreck"
      ],
      "case_sensitive": false,
      "context_notes": "Scatological term",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Very high"
    },
    {
      "word": "scheisse",
      "severity": 2,
      "categories": [
        "general",
        "scatological"
      ],
      "variations": [
        "scheiße",
        "sch31sse",
        "sch31ße",
        "kacke"
      ],
      "case_sensitive": false,
      "context_notes": "Universal German profanity, equivalent to 'shit'",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "compound_potential": "Very high - Scheissdreck, Scheisskerl, etc."
    },
    {
      "word": "scheisser",
      "severity": 2,
      "categories": [
        "scatological",
        "general"
      ],
      "variations": [
        "scheißer",
        "sch31ss3r",
        "s*heisser"
      ],
      "case_sensitive": false,
      "context_notes": "Scatological term",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Very high"
    },
    {
      "word": "scheisshaus",
      "severity": 1,
      "categories": [
        "scatological",
        "general"
      ],
      "variations": [
        "scheißhaus",
        "sch31ssh@us",
        "s*heisshaus"
      ],
      "case_sensitive": false,
      "context_notes": "Scatological term",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Very high"
    },
    {
      "word": "scheisskerl",
      "severity": 1,
      "categories": [
        "scatological",
        "general"
      ],
      "variations": [
        "scheißkerl",
        "sch31ssk3rl",
        "s*heisskerl"
      ],
      "case_sensitive": false,
      "context_notes": "Scatological term",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Very high"
    },
    {
      "word": "schiesser",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "schießer",
        "sch13ss3r",
        "s*hiesser"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "schietbüdel",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "sch13tbüd3l",
        "s*hietbüdel"
      ],
      "case_sensitive": false,
      "context_notes": "Northern German specific term",
      "target_type": "individual",
      "regions": [
        "northern_germany"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "schiissdreck",
      "severity": 1,
      "categories": [
        "scatological",
        "general"
      ],
      "variations": [
        "schiißdreck",
        "sch11ssdr3ck",
        "s*hiissdreck"
      ],
      "case_sensitive": false,
      "context_notes": "Swiss German specific term",
      "target_type": "individual",
      "regions": [
        "switzerland"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "schlampe",
      "severity": 3,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "schl@mpe",
        "schlmp"
      ],
      "case_sensitive": false,
      "context_notes": "Slut/whore equivalent, very offensive to women",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "schlappschwanz",
      "severity": 2,
      "categories": [
        "sexual",
        "body_parts",
        "general"
      ],
      "variations": [
        "schl@ppschw@nz",
        "s*hlappschwanz"
      ],
      "case_sensitive": false,
      "context_notes": "Sexual/vulgar term",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "schmarrn",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "schm@rrn",
        "s*hmarrn"
      ],
      "case_sensitive": false,
      "context_notes": "Bavarian/Southern German specific term",
      "target_type": "individual",
      "regions": [
        "bavaria"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "schmierfink",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "schm13rf1nk",
        "s*hmierfink"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "schnackeln",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "schn@ck3ln",
        "s*hnackeln"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "schnarchnase",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "schn@rchn@s3",
        "s*hnarchnase"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "schniedel",
      "severity": 1,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "schn13d3l",
        "s*hniedel"
      ],
      "case_sensitive": false,
      "context_notes": "Sexual/vulgar term",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "schw@nz",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "s*hw@nz"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "schwachkopf",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "schw@chk0pf",
        "s*hwachkopf"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Low - already compound"
    },
    {
      "word": "schwachmaat",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "schw@chm@@t",
        "s*hwachmaat"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "schwanz",
      "severity": 2,
      "categories": [
        "sexual",
        "body_parts"
      ],
      "variations": [
        "schw@nz",
        "schwz"
      ],
      "case_sensitive": false,
      "context_notes": "Vulgar term for penis, also means 'tail'",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium - Schwanzlutscher, etc."
    },
    {
      "word": "schwanzgesicht",
      "severity": 2,
      "categories": [
        "sexual",
        "body_parts",
        "general"
      ],
      "variations": [
        "schw@nzg3s1cht",
        "s*hwanzgesicht"
      ],
      "case_sensitive": false,
      "context_notes": "Sexual/vulgar term",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Low - already compound"
    },
    {
      "word": "schwanzlutscher",
      "severity": 2,
      "categories": [
        "sexual",
        "body_parts",
        "general"
      ],
      "variations": [
        "schw@nzlutsch3r",
        "s*hwanzlutscher"
      ],
      "case_sensitive": false,
      "context_notes": "Sexual/vulgar term",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "schwein",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "schw31n",
        "s*hwein"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "schweinebacke",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "schw31n3b@ck3",
        "s*hweinebacke"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "schweinehund",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "schw31n3hund",
        "s*hweinehund"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Low - already compound"
    },
    {
      "word": "schweinepriester",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "schw31n3pr13st3r",
        "s*hweinepriester"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "schwuchtel",
      "severity": 4,
      "categories": [
        "hate_speech",
        "slurs",
        "lgbtq"
      ],
      "variations": [
        "schwu4tel",
        "schwt"
      ],
      "case_sensitive": false,
      "context_notes": "Homophobic slur, extremely offensive to LGBTQ+ community",
      "target_type": "individual",
      "regions": [
        "germany",
        "austria"
      ],
      "compound_potential": "Low - already specific"
    },
    {
      "word": "schwuler",
      "severity": 3,
      "categories": [
        "lgbtq",
        "slurs"
      ],
      "variations": [
        "schw*ler",
        "schwul3r"
      ],
      "case_sensitive": false,
      "context_notes": "Can be neutral or offensive depending on context and intent",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "spast",
      "severity": 3,
      "categories": [
        "hate_speech",
        "slurs",
        "disability"
      ],
      "variations": [
        "sp@st",
        "spst"
      ],
      "case_sensitive": false,
      "context_notes": "Ableist slur derived from 'spastic', offensive to disabled community",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "specify regional usage if applicable",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "sp3c1fy r3g10n@l us@g3 1f @ppl1c@bl3",
        "s*ecify regional usage if applicable"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "strohkopf",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "str0hk0pf",
        "s*rohkopf"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Low - already compound"
    },
    {
      "word": "tittchen",
      "severity": 1,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "t1ttch3n",
        "t*ttchen"
      ],
      "case_sensitive": false,
      "context_notes": "Sexual/vulgar term",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "titten",
      "severity": 1,
      "categories": [
        "sexual",
        "body_parts",
        "general"
      ],
      "variations": [
        "t1tt3n",
        "t*tten"
      ],
      "case_sensitive": false,
      "context_notes": "Sexual/vulgar term",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "trampel",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "tr@mp3l",
        "t*ampel"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "trantüte",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "tr@ntüt3",
        "t*antüte"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "trottel",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "tr0tt3l",
        "t*ottel"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "tschoch",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "tsch0ch",
        "t*choch"
      ],
      "case_sensitive": false,
      "context_notes": "Austrian German specific term",
      "target_type": "individual",
      "regions": [
        "austria"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "tubel",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "tub3l",
        "t*bel"
      ],
      "case_sensitive": false,
      "context_notes": "Swiss German specific term",
      "target_type": "individual",
      "regions": [
        "switzerland"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "tussi",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "tußi",
        "tuss1",
        "t*ssi"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "verdammt",
      "severity": 1,
      "categories": [
        "general",
        "religious"
      ],
      "variations": [
        "verd@mmt",
        "verdmt",
        "verflucht"
      ],
      "case_sensitive": false,
      "context_notes": "Mild German curse, equivalent to 'damn'",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "compound_potential": "High - verdammte Scheisse, etc."
    },
    {
      "word": "verify the term with native speakers",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "v3r1fy th3 t3rm w1th n@t1v3 sp3@k3rs",
        "v*rify the term with native speakers"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "vögeln",
      "severity": 1,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "vög3ln",
        "v*geln"
      ],
      "case_sensitive": false,
      "context_notes": "Sexual/vulgar term",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "vollhonk",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "v0llh0nk",
        "v*llhonk"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "vollpfosten",
      "severity": 1,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "vollpf0sten",
        "vlpfstn"
      ],
      "case_sensitive": false,
      "context_notes": "Complete post/idiot, mild to moderate insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Low - already compound"
    },
    {
      "word": "volltrottel",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "v0lltr0tt3l",
        "v*lltrottel"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "w1chser",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "w1chs3r",
        "w*chser"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "walross",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "walroß",
        "w@lr0ss",
        "w*lross"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "weichei",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "w31ch31",
        "w*ichei"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "wichse",
      "severity": 1,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "w1chs3",
        "w*chse"
      ],
      "case_sensitive": false,
      "context_notes": "Sexual/vulgar term",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "wichsen",
      "severity": 1,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "w1chs3n",
        "w*chsen"
      ],
      "case_sensitive": false,
      "context_notes": "Sexual/vulgar term",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "wichser",
      "severity": 2,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "w1chser",
        "w*chser",
        "wixer"
      ],
      "case_sensitive": false,
      "context_notes": "Masturbator insult, moderately offensive",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "wichsfresse",
      "severity": 1,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "wichsfreße",
        "w1chsfr3ss3",
        "w*chsfresse"
      ],
      "case_sensitive": false,
      "context_notes": "Sexual/vulgar term",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "witzfigur",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "w1tzf1gur",
        "w*tzfigur"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "wurm",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "w*rm"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "wurst",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "w*rst"
      ],
      "case_sensitive": false,
      "context_notes": "Common German profanity/insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium"
    },
    {
      "word": "zipfe",
      "severity": 1,
      "categories": [
        "slurs",
        "general"
      ],
      "variations": [
        "z1pf3",
        "z*pfe"
      ],
      "case_sensitive": false,
      "context_notes": "Austrian German specific term",
      "target_type": "individual",
      "regions": [
        "austria"
      ],
      "compound_potential": "Medium"
    }
  ]
} as const

export type DEType = typeof DE
